import styled from 'styled-components/macro';

export const AnomsMapWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
`;
